const OnBlurDirective = function () {
    return function (scope, element, attrs) {
        element.on("blur", function () {
            scope.$apply(attrs.onBlur);
        });
    };
};

export { OnBlurDirective };